// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3iMu7","footer":"ModalCreateQualiphyProcedure_footer__3-0Yc","additionData":"ModalCreateQualiphyProcedure_additionData__3GDi7"};